module.exports = "/images/somaliland.svg?b12847ff456f0f251365c971df313e5a";